import { render, staticRenderFns } from "./GestaoEntregaLista.vue?vue&type=template&id=0eec5ab7&"
import script from "./GestaoEntregaLista.vue?vue&type=script&lang=js&"
export * from "./GestaoEntregaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports